import { Box } from "@mui/material";
import { clickToLinkHandler } from "../../../helpers/utils";
import SignatureIcon from "../../common/icons/signatureIcon";
import COLORS from "../../../colors";
import React from "react";

type InvestmentSignatureBlockRowActionProps = {
  dataTestId: string;
  orgId: number;
  dealId: number;
  dealInvestorId: number;
  dealLegalEntityInvestmentId: number;
  itemIndex: number;
};
export const InvestmentSignatureBlockRowAction = (
  props: InvestmentSignatureBlockRowActionProps
) => {
  const {
    dataTestId,
    orgId,
    dealId,
    dealInvestorId,
    dealLegalEntityInvestmentId,
    itemIndex,
  } = props;
  return (
    <Box
      data-testid={dataTestId}
      display={"flex"}
      justifyContent={"flex-end"}
      alignItems={"center"}
      key={"row-actions-" + itemIndex}
      className="signature-icon"
      onClick={() => {
        clickToLinkHandler(
          `/${orgId}/deals/${dealId}/investors/${dealInvestorId}/investment/${dealLegalEntityInvestmentId}/signature-block`
        );
      }}
    >
      <SignatureIcon fill={COLORS.SECONDARY_COLOR_700} />
    </Box>
  );
};
